//  AdminChecklist.js
import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import {
  collection,
  query,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firestore as db } from "../../firebase";

import ChecklistForm from "./ChecklistForm";
import AdminChecklistView from "./AdminChecklistView";

const AdminChecklist = ({ email }) => {
  const [tasks, setTasks] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [assigningChecklist, setAssigningChecklist] = useState(null);
  const [assignEmail, setAssignEmail] = useState("");
  const [isAssignDialogOpen, setIsAssignDialogOpen] = useState(false);

  // NEW: Add active only filter state
  const [showActiveOnly, setShowActiveOnly] = useState(true);

  useEffect(() => {
    if (!email) {
      console.error("No email passed to AdminChecklist.");
      return;
    }

    // ORIGINAL: Fetch all checklists created by the user
    // const adminChecklistsQuery = query(
    //   collection(db, "checklists"),
    //   where("createdBy", "==", email)
    // );

    // NEW: Fetch checklists with active status filtering
    // For admins, show all checklists created by users under their management
    const adminChecklistsQuery = query(collection(db, "checklists"));

    const unsubscribe = onSnapshot(adminChecklistsQuery, (snapshot) => {
      const fetchedTasks = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // ORIGINAL: Set all tasks without filtering
      // setTasks(fetchedTasks);

      // NEW: Apply active filter
      const filteredTasks = showActiveOnly
        ? fetchedTasks.filter((task) => task.IsActive === true)
        : fetchedTasks;
      setTasks(filteredTasks);
    });

    return () => unsubscribe();
  }, [email, showActiveOnly]); // NEW: Add showActiveOnly as dependency

  const handleEditChecklist = (checklist) => {
    setSelectedChecklist(checklist);
    setOpenForm(true);
  };

  const handleAssign = async () => {
    if (!assignEmail || !assigningChecklist) return;

    const newChecklist = {
      ...assigningChecklist,
      originalChecklistId: assigningChecklist.id,
      assignedTo: assignEmail,
    };

    delete newChecklist.id;

    try {
      await addDoc(collection(db, "assignedChecklists"), newChecklist);
      console.log("Checklist assigned!");
    } catch (err) {
      console.error("Failed to assign checklist:", err);
    }

    setAssigningChecklist(null);
    setAssignEmail("");
    setIsAssignDialogOpen(false);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setSelectedChecklist(null);
  };

  const handleSaveChecklist = async () => {
    handleCloseForm();
  };

  return (
    <Container>
      <Box
        sx={{
          my: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4">Admin Checklist</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setSelectedChecklist(null);
            setOpenForm(true);
          }}
        >
          + Create Checklist
        </Button>
      </Box>

      {/* NEW: Active only filter checkbox */}
      <Box sx={{ my: 2, display: "flex", alignItems: "center" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
          }}
        >
          <input
            type="checkbox"
            checked={showActiveOnly}
            onChange={(e) => setShowActiveOnly(e.target.checked)}
            style={{ marginRight: "4px" }}
          />
          Active only
        </label>
      </Box>

      {openForm && (
        <ChecklistForm
          email={email}
          onClose={handleCloseForm}
          selectedChecklist={selectedChecklist}
          onSave={handleSaveChecklist}
        />
      )}

      <AdminChecklistView
        tasks={tasks}
        onEdit={handleEditChecklist}
        onAssign={(checklist) => {
          setAssigningChecklist(checklist);
          setIsAssignDialogOpen(true);
        }}
      />

      <Dialog
        open={isAssignDialogOpen}
        onClose={() => setIsAssignDialogOpen(false)}
      >
        <DialogTitle>Assign Checklist</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Enter user email"
            value={assignEmail}
            onChange={(e) => setAssignEmail(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsAssignDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAssign} variant="contained" color="primary">
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AdminChecklist;
